import request from './requestUtils'

interface RebucketOptimizelyResponse {
  optimizelyExperiments: Record<string, App.OptimizelyExperimentDetails | undefined>
  optimizelyFeatureFlags: App.OptimizelyFeatureFlag
  resolvedTrackingId: string
}

export interface RebucketOptimizelyRequestBody {
  regionCode: string
}

/**
 * Re-bucket Optimizely experiments after user login
 *
 * Calls the server-side re-bucketing endpoint which re-runs Optimizely
 * bucketing with the authenticated user's stitched seed ID.
 *
 * Pass `regionCode` from Redux `geo.currentRegionCode` so rebucket POSTs (no `/{region}/` in the URL)
 * match the visible storefront region for audience targeting.
 *
 * Note: This endpoint is on the SSR server (customer portal), not the API backend.
 * We use an empty string as endpointOverride to make the request relative to the current domain.
 *
 * @returns Updated experiment decisions and resolved tracking ID
 */
export async function rebucketOptimizely(
  body: RebucketOptimizelyRequestBody,
): Promise<RebucketOptimizelyResponse | undefined> {
  return await request.post<RebucketOptimizelyResponse, RebucketOptimizelyRequestBody>(
    '/api/optimizely/rebucket',
    body,
    {},
    '',
  )
}
